import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CONFIG from '../../../../../app.config';
import DefaultProfileImageSvg from '../svgs/DefaultProfileImageSvg';

const ProfileImageWithFallback = ({ pic, localSrc, presentationOnly }) => {
  const [srcError, setSrcError] = useState(false);

  if (!localSrc && (!pic.name || srcError)) {
    return <DefaultProfileImageSvg />;
  }

  return (
    <img
      className="sensitive-data"
      alt={pic?.altText && !presentationOnly ? pic.altText : ''}
      title={pic?.altText || ''}
      role={presentationOnly ? 'presentation' : undefined}
      src={
        localSrc
        || `${CONFIG.S3_BUCKET_URL}${pic.name}-200x200.${pic.extension}`
      }
      onError={setSrcError}
    />
  );
};

ProfileImageWithFallback.propTypes = {
  pic: PropTypes.shape({
    altText: PropTypes.string,
    extension: PropTypes.string,
    name: PropTypes.string,
  }),
  localSrc: PropTypes.string,
  presentationOnly: PropTypes.bool,
};

export { ProfileImageWithFallback };
